import styled from '@emotion/styled';

const CardValue = styled.span({
  fontWeight: 'bold',
  marginBottom: '1.6rem',
});

export default CardValue;
